module.exports = __webpack_public_path__ + "b7b72b029f777c18a641d8ed6afb59d1.png";